import React from "react"
import {Button} from "@material-ui/core"
import AddIcon from "@material-ui/icons/Add"

import {CreateOfferModal} from "./CreateOfferModal"

type CreateOfferButtonProps = {
	customerID: string
	onSuccess: () => void
	enableOneOffOffers?: boolean
	enablePlanOffers?: boolean
	minInstalmentAmount?: number
}

function CreateOfferButton({
	customerID,
	onSuccess,
	enableOneOffOffers = true,
	enablePlanOffers = false,
	minInstalmentAmount = 10,
}: CreateOfferButtonProps) {
	const [createModalOpen, setCreateModalOpen] = React.useState(false)

	const handleSuccess = () => {
		setCreateModalOpen(false)
		onSuccess()
	}

	return (
		<>
			<Button
				variant="outlined"
				color="primary"
				startIcon={<AddIcon />}
				onClick={() => setCreateModalOpen(true)}
				size="small"
			>
				CREATE OFFER
			</Button>
			{createModalOpen && (
				<CreateOfferModal
					customerID={customerID}
					onClose={() => setCreateModalOpen(false)}
					onSuccess={handleSuccess}
					enableOneOffOffers={enableOneOffOffers}
					enablePlanOffers={enablePlanOffers}
					minInstalmentAmount={minInstalmentAmount}
				/>
			)}
		</>
	)
}

export {CreateOfferButton}
